import CallbackPageSubscription from '@/routes/callback/subscription/CallbackPageSubscription'
import type { RouteFactory } from '@/routing/types'

/**
 * Creates callback routes for external service integrations.
 * Handles post-payment and subscription success callbacks.
 */
export const createCallbackRoutes: RouteFactory = () => [
  {
    path: 'callback/subscription/success',
    element: <CallbackPageSubscription />,
  },
]
